/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
// Core Libraries
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
// Interfaces
import { APIError } from '@support/api/common/error.interface';
import { RestoreServiceSuccess } from '@experience/landing/common/interfaces/restore-service-success.interface';

/**
 * Restore service. function related to restoring services of a customer
 */

@Injectable(
  { providedIn: 'root' }
)
export class RestoreService {
  /**
   * Subject for restore service errors
   */
  public restoreServiceErrors: Subject<APIError>;
  /**
   * Observable for restore service errors
   */
  public restoreServiceErrors$: Observable<APIError>;
  /**
   * Subject for restore service success
   */
  public restoreSuccessSubject: Subject<RestoreServiceSuccess>;
  /**
   * Observable for restore service success
   */
  public restoreSuccessSubject$: Observable<RestoreServiceSuccess>;

  constructor() {
    this.restoreServiceErrors = new Subject();
    this.restoreServiceErrors$ = this.restoreServiceErrors.asObservable();
    this.restoreSuccessSubject = new Subject();
    this.restoreSuccessSubject$ = this.restoreSuccessSubject.asObservable();
  }

  /**
   * Set the Error Message when API fails or blank response is returned.
   * @param error string
   * @returns void
   */
  public setErrorMessage(error: string): void {
    const errorObject = {
      userMessage: error,
    };
    this.restoreServiceErrors.next(errorObject);
  }
  /**
   * Emits the subject based on whether API 2045 is called or not
   * @param orderId string
   * @param isImeiBlock boolean
   * @returns void
   */
  public setBlockedUnblocked(orderId: string, isImeiBlock: boolean): void {
    this.restoreSuccessSubject.next({ orderId: orderId, isBlocked: isImeiBlock });
  }
}
